module.exports = __webpack_public_path__ + "img/shiping.33cd9720.jpg";